<template>
  <div class="banner section">
    <div class="banner-inner hero is-fullheight">
      <div class="banner-item banner-item--empty" />
      <div class="banner-item">
        <div class="container">
          <div class="brand">
            <h1
              class="brand__name is-size-1 is-size-2-mobile has-text-white has-text-centered is-unselectable"
            >
              Oławska Telewizja Kablowa
            </h1>
            <p
              class="brand__slogan is-size-3-tablet is-size-4-mobile has-text-info has-text-centered is-unselectable"
            >
              Telewizja i internet na miarę XXI wieku
            </p>
            <p></p>
            <div class="brand__buttons">
              <div class="columns is-desktop">
                <div class="column">
                  <div class="field has-addons">
                    <p class="control is-expanded">
                      <button
                        class="button button--left font--condensed is-info is-rounded is-fullwidth"
                        @click="scrollTo('tv')"
                      >
                        Telewizja
                      </button>
                    </p>
                    <p class="control is-expanded">
                      <button
                        class="button button--right font--condensed is-info is-rounded is-fullwidth"
                        @click="scrollTo('internet')"
                      >
                        Internet
                      </button>
                    </p>
                  </div>
                </div>
                <div class="column">
                  <router-link
                    to="/videos"
                    class="button font--condensed is-rounded is-info is-outlined is-fullwidth"
                    >Nasze materiały</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-item">
        <div class="container">
          <icon
            name="fa-chevron-down"
            class="scroll-down is-size-3 has-text-white"
            :class="{ 'scroll-down--hidden': scrolled }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "%helpers";

const SCROLL_TRESHOLD = 1;

export default {
  name: "hero",

  components: {
    Icon
  },

  data() {
    return {
      scrolled: false
    };
  },

  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > SCROLL_TRESHOLD;
    },

    scrollTo(step) {
      this.$scrollTo(`*[data-step="${step}"]`, 2000, {
        offset: -100
      });
    }
  },

  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.banner {
  background: url("../../assets/img/network.png") no-repeat center / cover,
    linear-gradient(to bottom, $primary2 20%, $primary);
  padding-bottom: 100px;
  box-shadow: inset 0 -250px 250px -70px $primary;

  &-item--empty {
    height: 3rem;
  }
}

.banner-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.brand {
  text-align: center;
  padding: 50px;
  align-items: center;

  @include until($tablet) {
    padding: 0;
  }

  &__name {
    font-family: $family-serif;
    font-weight: 900;
    text-shadow: 0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.3);
    padding: 0 1rem;
  }

  &__slogan {
    font-family: $family-sans-serif-wide;
    font-weight: 500;
    color: $info;
    padding: 0 1rem;
  }

  &__buttons {
    padding-top: 1rem;

    @include until($desktop) {
      display: inline-block;
    }
  }
}

.button {
  font-size: 0.8rem;
  height: auto;

  padding: {
    top: 1rem;
    bottom: 1rem;
  }

  @include until($tablet) {
    font-size: 0.65rem;
  }

  &--left {
    padding-left: 4rem;
    padding-right: 1rem;

    @include until($tablet) {
      padding-left: 2rem;
      padding-right: 0.5rem;
    }
  }

  &--right {
    padding-right: 4rem;
    padding-left: 1rem;

    @include until($tablet) {
      padding-right: 2rem;
      padding-left: 0.5rem;
    }
  }
}

.scroll-down {
  animation: scroll 1.5s infinite;
  position: relative;
  transition: 1s;
  text-shadow: 0 0 0.3rem $info;

  &--hidden {
    transition: 0.5s;
    opacity: 0;
  }

  @keyframes scroll {
    from,
    30% {
      top: -1.5rem;
    }

    50% {
      top: 0;
    }

    70%,
    to {
      top: -1.5rem;
    }
  }
}
</style>
